export default __webpack_public_path__ + "static/media/941.cc8cc99d.png";